{/*
  * DspAlxAlxReportingPage.tsx
  * https://dash.applovin.com/documentation/mediation/auctions/dsps/alx-reporting
  * Documentation > MAX Demand Partners > DSPs > ALX Reporting
  */}
import React, { FunctionComponent } from 'react';
import { DocsPageModule } from 'UI-Dash-Commons-UI';

type DspAlxReportingPageProps = {
    linkTargetTopPosition?: number;
}

const DspAlxReportingPage: FunctionComponent<DspAlxReportingPageProps> = ( { linkTargetTopPosition } ) =>
{
    return (
        <>
            <DocsPageModule.DocsPageHeader linkTargetTopPosition={linkTargetTopPosition} text={'ALX Reporting'}
                                           type={DocsPageModule.DocsPageHeaderType.HEADING_1}/>

            <DocsPageModule.DocsPageContent>
                <DocsPageModule.DocsPageContentText text={'ALX Reporting ('} />
                <DocsPageModule.DocsPageContentAnchor
                    to={'/o/mediation/alx_reporting'}
                    text={'MAX > Mediation > Analyze > ALX Reporting'}
                    newWindow={true}
                />
                <DocsPageModule.DocsPageContentText
                    text={') provides insights that help you to understand your spend within the AppLovin Exchange. '
                        + 'You can run hourly, daily, or weekly reports to analyze trends and deep-dive into your app’s performance. '
                        + 'Schedule important reports to have them delivered via email on a regular basis.'}
                />
            </DocsPageModule.DocsPageContent>

            <DocsPageModule.DocsPageHeader linkTargetTopPosition={linkTargetTopPosition} text={'Notes'}
                                           type={DocsPageModule.DocsPageHeaderType.HEADING_1}/>
            <DocsPageModule.DocsPageUnorderedList>
                <DocsPageModule.DocsPageBulletPoint>Retention is 90 days back.</DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint>Scheduled reports get sent anytime from 3:00&#xA0;AM UTC to 16:00&#xA0;PM UTC each day. </DocsPageModule.DocsPageBulletPoint>
            </DocsPageModule.DocsPageUnorderedList>

            <DocsPageModule.DocsPageHeader linkTargetTopPosition={linkTargetTopPosition} text={'Metrics'}
                                           type={DocsPageModule.DocsPageHeaderType.HEADING_1}/>
            <DocsPageModule.DocsPageUnorderedList>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Wins'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Win Rate'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Impressions'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Clicks'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'CTR'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Clear Rate'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Display Rate'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Est Revenue'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'CPM'} /></DocsPageModule.DocsPageBulletPoint>
            </DocsPageModule.DocsPageUnorderedList>
            <DocsPageModule.DocsPageHeader linkTargetTopPosition={linkTargetTopPosition} text={'Dimensions'}
                                           type={DocsPageModule.DocsPageHeaderType.HEADING_1}/>
            <DocsPageModule.DocsPageUnorderedList>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Day'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Hour'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Deal ID — coming soon'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Platform'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Country'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Ad Type'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Has IDFA'} /></DocsPageModule.DocsPageBulletPoint>
                <DocsPageModule.DocsPageBulletPoint><DocsPageModule.DocsPageContentText text={'Seat ID'} /></DocsPageModule.DocsPageBulletPoint>
            </DocsPageModule.DocsPageUnorderedList>

        </>
    )
}

export default DspAlxReportingPage;
